import { render, staticRenderFns } from "./LocalIdField.vue?vue&type=template&id=d7781aa4&scoped=true&"
import script from "./LocalIdField.vue?vue&type=script&lang=js&"
export * from "./LocalIdField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7781aa4",
  null
  
)

export default component.exports